import React from 'react';
import {
  StatsGrid,
  StatCard,
  StatCardContent,
  StatText,
  StatCount,
  StatDescription,
  StatIconWrapper,
} from './styles';

type StatItem = {
  description: string;
  value: number;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  bg?: string;
  fg?: string;
};

type Palette = {
  bg: string;
  fg: string;
};

type StatCounterProps = {
  items: StatItem[];
  palettes?: Palette[];
};

const defaultPalettes: Palette[] = [
  { bg: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)', fg: '#fff' },
  { bg: 'linear-gradient(135deg, #06B6D4 0%, #3B82F6 100%)', fg: '#fff' },
  { bg: 'linear-gradient(135deg, #10B981 0%, #22D3EE 100%)', fg: '#fff' },
  { bg: 'linear-gradient(135deg, #F59E0B 0%, #F472B6 100%)', fg: '#fff' },
  { bg: 'linear-gradient(135deg, #EF4444 0%, #F59E0B 100%)', fg: '#fff' },
  { bg: 'linear-gradient(135deg, #0EA5E9 0%, #6366F1 100%)', fg: '#fff' },
];

export default function StatCounter({ items, palettes = defaultPalettes }: StatCounterProps) {
  return (
    <StatsGrid>
      {items.map((item, idx) => {
        const palette = {
          bg: item.bg ?? palettes[idx % palettes.length].bg,
          fg: item.fg ?? palettes[idx % palettes.length].fg,
        };
        const Icon = item.icon;
        return (
          <StatCard key={`stat-${idx}`} $bg={palette.bg} $fg={palette.fg}>
            <StatCardContent $fg={palette.fg}>
              <StatText>
                <StatCount variant="h3">{new Intl.NumberFormat().format(item.value)}</StatCount>
                <StatDescription variant="body1">{item.description}</StatDescription>
              </StatText>
              <StatIconWrapper $fg={palette.fg}>{Icon ? <Icon /> : null}</StatIconWrapper>
            </StatCardContent>
          </StatCard>
        );
      })}
    </StatsGrid>
  );
}
